import angular from 'angular';
import uiRouter from 'angular-ui-router';
import serviceComponent from './service.component';
import serviceListComponent from './service-list.component';
import serviceDetailComponent from './service-detail.component';
import serviceService from './service.service';

let serviceModule = angular.module('service', [
  uiRouter
])

.service('Service', serviceService)

.config(($stateProvider, $urlRouterProvider) => {
  "ngInject";

  $urlRouterProvider.otherwise('/service');

  $stateProvider
    .state('service', {
      component: 'service'
    })
    .state('service.list', {
      url: '/service',
      component: 'serviceList'
    })
    .state('service.create', {
      url: '/service/new',
      component: 'serviceDetail',
      params: {
      	id: ""
      }
    })
    .state('service.edit', {
      url: '/service/:id/edit',
      component: 'serviceDetail',
      params: {
        id: ""
      }
    });
})

.component('service', serviceComponent)
.component('serviceList', serviceListComponent)
.component('serviceDetail', serviceDetailComponent)

.name;

export default serviceModule;



// WEBPACK FOOTER //
// ./client/app/components/service/service.js